import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-report-list',
  templateUrl: './sms-report-list.component.html',
  styleUrls: ['./sms-report-list.component.css']
})
export class SmsReportListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
